import styled from 'styled-components';
import { Table } from '../../elements';

export const DownloadButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StyledTable = styled(Table)`
  .rt-th:nth-child(1),
  .rt-td:nth-child(1) {
    display: block;
  }
  .rt-thead.-filters {
    top: 30px;
  }
`;
